import { defaultRenderFileType } from '../../../../common/renderer/renderer-settings';
import { RenderFileType } from '../../../../common/renderer/types';
import { useRenderViewContext } from '../context';
import { friendlyRenderType } from '../utils';
import { ControlRoot, ControlRowContent, ControlRowLabel, RadioButton, RadioButtonsWrap } from './shared';

export const FileType = () => {
  const { options, setOptions } = useRenderViewContext();
  const renderFileType = options.renderFileType || defaultRenderFileType;

  return (
    <ControlRoot>
      <ControlRowLabel>File type</ControlRowLabel>
      <ControlRowContent>
        <RadioButtonsWrap>
          <RadioButton
            checked={renderFileType === RenderFileType.PNG}
            onSelect={() => {
              setOptions({ ...options, renderFileType: RenderFileType.PNG });
            }}
            label={friendlyRenderType(RenderFileType.PNG)}
          />
          <RadioButton
            checked={renderFileType === RenderFileType.PDF}
            onSelect={() => {
              setOptions({ ...options, renderFileType: RenderFileType.PDF });
            }}
            label={friendlyRenderType(RenderFileType.PDF)}
          />
        </RadioButtonsWrap>
      </ControlRowContent>
    </ControlRoot>
  );
};
